import AppConstants from '../../../../constants/AppConstants';
import DashboardActions from '../../../../actions/DashboardActions';
import moment from 'moment-timezone';
import config from '../../../../config';
import store from '../../../../stores/redux';
import { metrics } from 'utils/ReportComponent/config';

export const actions = {
    getLastData() {
        const user = store.getState().user || {};
        const timezone = user?.timezone || 'UTC';
        const currency = user?.publisher?.account?.balance?.currency || 'USD';

        const columns = Object.keys(metrics).filter((m) => metrics[m].visible === true);

        const params = {
            publishers: [],
            group_by: 'Day',
            from_day: moment().startOf('day').subtract(6, 'days').format(config.reportHourFormat),
            to_day: moment().endOf('day').add(1, 'days').format(config.reportHourFormat),
            use_registered_date: '0',
            registered_from_day: moment().startOf('day').subtract(6, 'days').format(config.reportHourFormat),
            registered_to_day: moment().endOf('day').add(1, 'days').format(config.reportHourFormat),
            bind_actions: 'time',
            timezone,
            currency,
            columns,
            totals: '0',
            isHomePage: 1,
            isAdvertiser: 1
        };

        DashboardActions.getLastData(params);
    },

    clear() {
        return { type: AppConstants.DASHBOARD_CLEAR };
    }
};
